import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "proposal-matrix-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "proposal-matrix__details"
}
const _hoisted_3 = {
  class: "proposal-matrix__table",
  role: "table"
}
const _hoisted_4 = { class: "proposal-matrix__header" }
const _hoisted_5 = {
  key: 0,
  scope: "col",
  class: "proposal-matrix__table-header-organizer"
}
const _hoisted_6 = {
  key: 1,
  scope: "col",
  class: "proposal-matrix__table-header-participant",
  colspan: "2"
}
const _hoisted_7 = { class: "proposal-matrix__table-participant-header-avatar" }
const _hoisted_8 = { class: "proposal-matrix__table-participant-header-name" }
const _hoisted_9 = {
  key: 2,
  scope: "col",
  class: "proposal-matrix__table-action-header"
}
const _hoisted_10 = { class: "proposal-matrix__table-row-label" }
const _hoisted_11 = { class: "proposal-matrix__table-day-label" }
const _hoisted_12 = { class: "proposal-matrix__table-day-time" }
const _hoisted_13 = {
  key: 0,
  class: "proposal-matrix__table-actions-participant"
}
const _hoisted_14 = { class: "voting-options-container" }
const _hoisted_15 = { class: "vote-option" }
const _hoisted_16 = { class: "vote-option" }
const _hoisted_17 = { class: "vote-option" }
const _hoisted_18 = {
  key: 1,
  class: "proposal-matrix__table-actions-organizer"
}
const _hoisted_19 = {
  key: 1,
  class: "proposal-matrix__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcAvatar = _resolveComponent("NcAvatar")!
  const _component_VoteYesIcon = _resolveComponent("VoteYesIcon")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_VoteNoIcon = _resolveComponent("VoteNoIcon")!
  const _component_VoteMaybeIcon = _resolveComponent("VoteMaybeIcon")!
  const _component_CreateIcon = _resolveComponent("CreateIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.proposal?.participants.length && $props.proposal?.dates.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_4, [
                ($props.mode === 'organizer')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_5, "   "))
                  : _createCommentVNode("", true),
                ($props.mode === 'participant')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString($options.t('calendar', 'Select your meeting availability')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.proposal.participants, (participant) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: 'head-' + participant.id,
                    scope: "col",
                    class: "proposal-matrix__table-participant-header"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_NcAvatar, {
                        user: participant.name || participant.address,
                        displayName: participant.name || participant.address,
                        disableTooltip: false,
                        isNoUser: true,
                        size: 32
                      }, null, 8, ["user", "displayName"]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(participant.name || participant.address), 1)
                    ])
                  ]))
                }), 128)),
                ($props.mode === 'organizer')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, "   "))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.datesGrouped, (group, groupIndex) => {
              return (_openBlock(), _createElementBlock("tbody", {
                key: group.key || groupIndex
              }, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(group.label), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.dates, (date) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: date.id,
                    class: "proposal-matrix__table-row"
                  }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString($options.dateTimeSpan(date.date)), 1),
                    ($props.mode === 'participant')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_NcCheckboxRadioSwitch, {
                              type: "radio",
                              buttonVariant: true,
                              buttonVariantGrouped: "horizontal",
                              name: 'vote-' + date.id,
                              value: $data.ProposalDateVote.Yes,
                              modelValue: $options.dateVoteValue(date),
                              "onUpdate:modelValue": ($event: any) => (_ctx.$emit('dateVote', { date: date, vote: $data.ProposalDateVote.Yes }))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_VoteYesIcon),
                                  _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Yes')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["name", "value", "modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_NcCheckboxRadioSwitch, {
                              type: "radio",
                              buttonVariant: true,
                              buttonVariantGrouped: "horizontal",
                              name: 'vote-' + date.id,
                              value: $data.ProposalDateVote.No,
                              modelValue: $options.dateVoteValue(date),
                              "onUpdate:modelValue": ($event: any) => (_ctx.$emit('dateVote', { date: date, vote: $data.ProposalDateVote.No }))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_VoteNoIcon),
                                  _createTextVNode(" " + _toDisplayString($options.t('calendar', 'No')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["name", "value", "modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_NcCheckboxRadioSwitch, {
                              type: "radio",
                              buttonVariant: true,
                              buttonVariantGrouped: "horizontal",
                              name: 'vote-' + date.id,
                              value: $data.ProposalDateVote.Maybe,
                              modelValue: $options.dateVoteValue(date),
                              "onUpdate:modelValue": ($event: any) => (_ctx.$emit('dateVote', { date: date, vote: $data.ProposalDateVote.Maybe }))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_VoteMaybeIcon),
                                  _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Maybe')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["name", "value", "modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.proposal.participants, (participant) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: participant.id + '-' + date.id,
                        class: "proposal-matrix__table-votes"
                      }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent($options.participantVoteIcon(participant.id, date.id)), {
                          title: $options.participantVoteLabel(participant.id, date.id),
                          size: 20
                        }, null, 8, ["title"]))
                      ]))
                    }), 128)),
                    ($props.mode === 'organizer')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                          _createVNode(_component_NcButton, {
                            variant: "tertiary",
                            title: $options.t('calendar', 'Create a meeting for this date and time'),
                            onClick: ($event: any) => (_ctx.$emit('dateConvert', date))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CreateIcon)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Create')), 1)
                            ]),
                            _: 1
                          }, 8, ["title", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($options.t('calendar', 'No participants or dates available')), 1))
  ]))
}